import React, { FC } from 'react';

interface Props {
  label: string | number;
  value: string | number;
}

export const ProfileDescriptionItem = ({ label, value }: Props) => {
  return (
    <div className="flex justify-between mt-2 overflow-hidden">
      <span className="text-ink dark:text-ink-dark font-medium mr-2">{label}</span>
      <span className="text-inkMuted dark:text-inkMuted-dark text-sm">{value}</span>
    </div>
  );
};

const ProfileDescriptionContainer: FC = (props) => {
  return <div className="my-8">{props.children}</div>;
};

export default ProfileDescriptionContainer;
